import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useFeatureFlag} from "@mytour/platform";
import {Trans as Translate} from "react-i18next";
import {NavLink as Link} from "react-router";
import {NavItem, NavLink} from "reactstrap";

export const EntitiesMenu = (props) => {
  // "Demandes" (RDV en ligne, Story 4.1b) is gated by the feature flag (#559):
  // the online-booking hub is not shown to accounts without the module.
  const rdvEnLigneEnabled = useFeatureFlag("rdv-en-ligne");

  return (
    <>
      <NavItem>
        <NavLink
          tag={Link}
          to="/planning"
          id="events-nav"
          className="d-flex align-items-center"
          onClick={props.onClick}
        >
          <FontAwesomeIcon icon="calendar-alt" />
          <span className="d-none d-lg-block">
            <Translate i18nKey="global.menu.home">Home</Translate>
          </span>
        </NavLink>
      </NavItem>
      {rdvEnLigneEnabled && (
        <NavItem>
          <NavLink
            tag={Link}
            to="/rdv-requests"
            id="rdv-requests-nav"
            className="d-flex align-items-center"
            onClick={props.onClick}
          >
            <FontAwesomeIcon icon="clipboard-list" />
            <span className="d-none d-lg-block">Demandes</span>
          </NavLink>
        </NavItem>
      )}
      <NavItem>
        <NavLink
          tag={Link}
          to="/customer"
          id="customers-nav"
          className="d-flex align-items-center"
          onClick={props.onClick}
        >
          <FontAwesomeIcon icon="users" />

          <span className="d-none d-lg-block">
            <Translate i18nKey="global.menu.entities.customer" />
          </span>
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          tag={Link}
          to="/invoice"
          id="invoices-nav"
          className="d-flex align-items-center"
          onClick={props.onClick}
        >
          <FontAwesomeIcon icon="file-invoice-dollar" />

          <span className="d-none d-lg-block">
            <Translate i18nKey="global.menu.entities.invoice" />
          </span>
        </NavLink>
      </NavItem>
    </>
  );
};
